import React, { Component } from 'react'
import { connect } from 'react-redux';
import { compose } from 'redux';
import * as R from 'ramda';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import FileCopyOutlined from '@material-ui/icons/FileCopyOutlined';
import { withStyles } from '@material-ui/core/styles';

import { DialogStateContext } from './Context';

import { styles } from './styles';
import formsManagerAPI from '../../../config/api/formManagerAPI';


class CopyDialog extends Component {
    static contextType = DialogStateContext;
    state = {
        name: '',
        invalidName: false
    };

    handleOpen = () => {
        this.setState({
            name: `Copy of ${this.props.form.name}`
        });
    };

    updateName = ({ target }) => {
        this.setState({ name: target.value });
    };

    handleSave = () => {
        formsManagerAPI.copyForm(this.props.form.urlFormId, this.postBody())
            .then(this.successHandler)
            .catch(this.errorHandler);
    };

    postBody = () => {
        const { userId, userName } = this.props.userProfile;
        const { name } = this.state;
        return { userId, userName, name };
    };

    successHandler = ({ data }) => {
        this.setState({ invalidName: false });
        this.props.handleCopy(data);
        this.context.handleClose();
    };

    errorHandler = ({ validationErrors }) => {
        const nameError = R.find(R.propEq('fieldName', 'name'), validationErrors);
        if (nameError) this.setState({ invalidName: nameError.message });
    }

    render() {
        const { classes } = this.props;
        const { open, handleClose } = this.context;

        return (
            <Dialog
                open={open}
                onClose={handleClose}
                onEnter={this.handleOpen}
                fullWidth
            >
                <div className={classes.header}>
                    <Typography variant="h6" color="inherit">
                        <FileCopyOutlined className={classes.icon} />
                        Copy Form
                    </Typography>
                </div>
                <DialogContent className={classes.content}>
                    <TextField
                        type="text"
                        name="name"
                        fullWidth
                        required
                        className={classes.copyTextField}
                        label="Form Name"
                        placeholder="Enter form name"
                        onChange={this.updateName}
                        value={this.state.name}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        helperText={this.state.invalidName && this.state.invalidName}
                        error={!!this.state.invalidName}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>cancel</Button>
                    <Button
                        color="primary"
                        className={classes.saveBtn}
                        onClick={this.handleSave}
                    >
                        save
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

const mapStateToProps = (state) => ({
    userProfile: state.user.profile,
});

export default compose(
    withStyles(styles),
    connect(mapStateToProps)
)(CopyDialog);
